import { useEffect, useState } from "react";
import { type SwatchSpec, swatchKey, tileSwatches } from "./swatches";

/**
 * The object URL of `spec`'s swatch (`swatches.ts`), or `null` until it has painted — or for good,
 * where it cannot paint. Re-renders once when the paint lands; a cached swatch is there on the first
 * render.
 */
export function useSwatchUrl(spec: SwatchSpec | null): string | null {
  const key = spec ? swatchKey(spec) : null;
  const [landed, setLanded] = useState<{ key: string; url: string } | null>(null);
  useEffect(() => {
    if (!spec || tileSwatches.peek(spec)) return;
    let live = true;
    tileSwatches.get(spec).then(
      (s) => {
        if (live) setLanded({ key: swatchKey(spec), url: s.url });
      },
      () => undefined,
    );
    return () => {
      live = false;
    };
    // `key` is the spec's identity; the spec object itself is rebuilt every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  if (!spec) return null;
  return tileSwatches.peek(spec)?.url ?? (landed?.key === key ? landed.url : null);
}
